import { render, staticRenderFns } from "./EditorTemplate.vue?vue&type=template&id=2578c424&scoped=true"
import script from "./EditorTemplate.vue?vue&type=script&lang=ts"
export * from "./EditorTemplate.vue?vue&type=script&lang=ts"
import style0 from "./EditorTemplate.vue?vue&type=style&index=0&id=2578c424&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2578c424",
  null
  
)

export default component.exports